export enum TabGroup {
  Customers = 'Customers',
  Customer = 'Customer',
  Providers = 'Providers',
  Provider = 'Provider',
  Drivers = 'Drivers',
  Freelance = 'Freelance',
  Shipments = 'Shipments',
  MyShipments = 'MyShipments',
  Dashboard = 'Dashboard',
  Tracking = 'Tracking',
  Invoices = 'Invoices',
  DeliveryNotes = 'DeliveryNotes',
  TrucksReport = 'TrucksReport',
  TransportationPayments = 'TransportationPayments',
  PaymentDetails = 'PaymentDetails',
}

export enum TabLabel {
  AllRequests = 'AllRequests',
  AllCustomers = 'AllCustomers',
  CompanyInfo = 'CompanyInfo',
  Contract = 'Contract',
  MadarContract = 'MadarContract',
  CustomerFleetContracts = 'CustomerFleetContracts',
  Trucks = 'Trucks',
  Vehicles = 'Vehicles',
  Drivers = 'Drivers',
  Trailers = 'Trailers',
  Users = 'Users',
  Receivers = 'Receivers',
  AllProviders = 'AllProviders',
  DriversTracking = 'DriversTracking',
  FleetConfiguration = 'FleetConfiguration',
  ShipmentTracking = 'ShipmentTracking',
  MobileTracking = 'MobileTracking',
  AVLTracking = 'AVLTracking',
  MyCustomers = 'MyCustomers',
  Financial = 'Financial',
  Transactions = 'Transactions',
  DaleelTracking = 'DaleelTracking',
}

export enum TabIndex {
  AllRequests = 1,
  AllCustomers = 0,
  CustomerCompanyInfo = 0,
  Contract = 1,
  MadarContract = 1,
  CustomerFleetContract = 2,
  Trucks = 1,
  Trailers = 2,
  Drivers = 3,
  CustomerUsers = 3,
  Receivers = 3,
  AllProviders = 0,
  ProviderCompanyInfo = 0,
  ProviderContract = 1,
  ProviderUsers = 4,
  OrderStatus = 0,
  DriversTracking = 0,
  ShipmentTracking = 1,
}

export enum CustomerTabIndex {
  None = 0,
  Assigned = 1,
  Accepted = 2,
  InTransit = 3,
  ArrivePickupLocation = 4,
  GoodsLoaded = 5,
  ArriveDropOffLocation = 6,
  GoodsDelivered = 7,
  Canceled = 8,
  NotFulfilled = 9,
}

export enum FleetTabIndex {
  None = 0,
  Assigned = 1,
  Accepted = 2,
  InTransit = 4,
  ArrivePickupLocation = 5,
  GoodsLoaded = 6,
  ArriveDropOffLocation = 7,
  GoodsDelivered = 8,
  Canceled = 9,
  NotFulfilled = 10,
}
